import React, { type FC } from 'react'
import { AppHeader as BaseAppHeader, Button, Logo, LogoSizes, useHeaderStyles } from '../../ui'
import { spacing } from '../../style-guide'
import { Link } from '@reach/router'

export const AppHeader: FC = () => {
  const { appHeaderWithBorder } = useHeaderStyles()

  const handleLogout = (): void => {
    window.alert('Surprise !!! This is not implemented yet.')
  }

  return (
    <BaseAppHeader className={appHeaderWithBorder}>
      <Logo size={LogoSizes.small} />
      <Link to="/" style={{ marginLeft: spacing.m, color: 'inherit' }}>
        Developer Portal
      </Link>
      <div style={{ flexGrow: 1 }} />
      <Button variant="text" onClick={handleLogout}>
        Logout
      </Button>
    </BaseAppHeader>
  )
}

AppHeader.displayName = 'AppHeader'
